import styles from "./BurgerButton.module.scss";
import cn from "classnames";

type BurgerButtonProps = {
  active: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const BurgerButton = ({ active, onClick }: BurgerButtonProps) => (
  <button
    aria-label="Toggle menu"
    className={cn(styles.burgerButton, {
      [styles.burgerButtonActive]: active,
    })}
    type="button"
    onClick={onClick}
  >
    <span />
    <span />
    <span />
  </button>
);
